import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/message/notify/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/message/notify/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/message/notify/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/message/notify/submit', params,options);

export const updateStatus = (params, options) =>
request.post('/api/v4ward/message/notify/updateStatus', qs.stringify(params),options);
